import { routes } from 'routerHistory';
import { AppTile } from '@shared/containers/appTile';
import { Constants } from '@shared/utils/constants';
import { ServiceTile } from '@shared/containers/serviceTile';
import CommonTile from '@shared/components/commonTile';
const registration = {
    // The following keys map to the enum values of Constants.EntityType
    App: {
        route: routes.marketplace,
        tileType: AppTile,
        identifier: 'ApplicationId',
        statePropertyName: 'apps'
    },
    Service: {
        route: routes.marketplaceServices,
        tileType: ServiceTile,
        identifier: 'ServiceId',
        statePropertyName: 'services'
    },
    CloudsIndustry: {
        route: routes.marketplaceCloudsIndustry,
        tileType: CommonTile,
        identifier: 'ApplicationId',
        statePropertyName: 'cloudsIndustry'
    },
    PrivateOffers: {
        route: routes.privateOffers,
        tileType: AppTile,
        identifier: 'ApplicationId',
        statePropertyName: 'apps'
    }
};
export function getEntityRegistration(entityType) {
    return registration[Constants.EntityType[`${entityType}`]];
}
export function getEntityRegistrationByView(viewName) {
    let result = null;
    for(const entityType in registration){
        if (registration[`${entityType}`].route && registration[`${entityType}`].route.name === viewName) {
            result = Constants.EntityType[`${entityType}`];
            break;
        }
    }
    return result;
}
export function getEntityDataState({ state, entityType }) {
    return state[registration[Constants.EntityType[`${entityType}`]].statePropertyName];
}
export function getAllEntityTypes() {
    const keys = Object.keys(Constants.EntityType);
    const result = [];
    keys.forEach((key)=>{
        if (typeof Constants.EntityType[`${key}`] === 'number') {
            result.push(Constants.EntityType[`${key}`]);
        }
    });
    return result;
}
